export default __webpack_public_path__ + "static/107977-3f03d14242a64513eec1cf815c14ebb1.jpg";